export default "__VITE_ASSET__BGgt5iRm__"